import { useSession } from 'next-auth/react';

export function useIsAbriStaff() {
  const { data: session } = useSession();
  return (
    session?.user?.isABRIStaff === true ||
    session?.user?.entitlements?.includes('abri-staff') === true
  );
}
